import { useNavigate } from 'react-router-dom';

/**
 * Returns to the previous in-app page, or home when there is none.
 */
export default function useGoBack() {
  const navigate = useNavigate();

  return () => {
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate('/');
  };
}
